<!--
//================================================================================
// ID:BC019
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:BC019
//
// <<Modification History>>
// Version  | Date       | Updated By            | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2022/11/01 | 富士通Japan株式会社    | 新規作成
// 01.01.00 | 2023/09/29 | 富士通Japan株式会社    | 令和5年度改修対応（3次リリース）
//================================================================================
-->
<template>
	<main class="contents__main">
		<step-bar :transKbn="form.transKbn"/>
		<error-message />
		<div class="contents__input-main">
			<div class="contents__title">
				<label class="contents__title--label"></label>
			</div>
			<br>
			<div>
				<label>申込み内容を確認してください。（まだ、申込みは完了していません）</label>
			</div>
			<br>
			<section>
				<h2 class="contents__h2 contents__mosikomi">現在のお住まいについて</h2>
				<table class="detail">
					<tbody>
						<div class="form-section">
							<div class="form-section-wrap">
								<p class="item-name">一緒に住んでいる方（申込者本人を含む）の年齢別の人数</p>
								<div class="contents-kazokuNinzu-first line-height">・１１歳以下：{{ disp.nuNinzu1Name }}</div>
								<div class="contents-kazokuNinzu line-height">・１２歳以上１７歳以下：{{ disp.nuNinzu2Name }}</div>
								<div class="contents-kazokuNinzu line-height">・１８歳以上６４歳以下：{{ disp.nuNinzu3Name }}</div>
								<div class="contents-kazokuNinzu-last line-height">・６５歳以上：{{ disp.nuNinzu4Name }}</div>
							</div>
						</div>
						<div class="form-section background__color--light-gray">
							<div class="form-section-wrap">
								<p class="item-name">一緒に住んでいる親族（申込者本人を含む）のうち寝たきりの病人等の人数</p>
								<div id="contents--name__area">
									<div class="contents-kazokuNinzu-first">{{ disp.nuNetakirininzuName }}</div>
								</div>
							</div>
						</div>
						<div class="form-section">
							<div class="form-section-wrap">
								<p class="item-name">一緒に住んでいる親族（申込者本人を含む）のうち心身障害者の人数と現在有効な手帳の等級等</p>
								<div class="contents-syogaiTokyu-first line-height">・人数：{{ disp.nuSyogaisyaninzuName }}</div>
								<div class="contents-syogaiTokyu-first margin-top-10 line-height">・手帳</div>
								<div v-if="disp.kbSintokyuName != ''" class="contents-syogaiTokyu2 line-height">〇 身体障害者手帳：{{ disp.kbSintokyuName }}</div>
								<div v-if="disp.kbAiteidoName != ''" class="contents-syogaiTokyu2 line-height">〇 愛の手帳：{{ disp.kbAiteidoName }}</div>
								<div v-if="disp.kbSeitokyuName != ''" class="contents-syogaiTokyu2 line-height">〇 精神障害者保健福祉手帳※：{{ disp.kbSeitokyuName }}</div>
								<div v-if="disp.kbSyogaitokyuName != ''" class="contents-syogaiTokyu2 line-height">※年金証書の障害等級：{{ disp.kbSyogaitokyuName }}</div>
							</div>
						</div>
						<div class="form-section background__color--light-gray">
							<div class="form-section-wrap">
								<p class="item-name">住宅の種類</p>
								<div id="contents--name__area">
									<div class="contents-kazokuNinzu-first">
										{{ disp.cdNowjyutakuName }}
										<caution-message
											:tyuibunItems="disp.jyutakuTyuiItems"
										/>
									</div>
								</div>
							</div>
						</div>
						<div class="form-section">
							<div class="form-section-wrap">
								<p class="item-name">親族・知人の住宅に住んでいる場合の状況</p>
								<div id="contents--name__area">
									<div class="contents-kazokuNinzu-first">{{ disp.kbNowjyutakuName }}</div>
								</div>
							</div>
						</div>
						<div class="form-section background__color--light-gray">
							<div class="form-section-wrap">
								<p class="item-name">住宅の構造</p>
								<div id="contents--name__area">
									<div class="contents-kazokuNinzu-first">{{ disp.kbJyutakukozoName }}</div>
								</div>
							</div>
						</div>
						<div class="form-section">
							<div class="form-section-wrap">
								<p class="item-name">住宅の間取り</p>
								<div id="contents--name__area">
									<div class="contents-kazokuNinzu-first">{{ disp.cdNowmadoriName }}</div>
								</div>
								<div class="margin-madoriTyui" style="margin-left: 17px;">
									<span class="contents__caution font-size line-height">※ 親族・知人の住宅に住んでいる方は、住宅全体の間取り</span>
								</div>
							</div>
						</div>
						<div class="form-section background__color--light-gray">
							<div class="form-section-wrap">
								<p class="item-name">住宅の専用面積</p>
								<div id="contents--name__area">
									<div class="contents-kazokuNinzu-first">
										<label v-if="disp.nuNowsenyo != '' && disp.nuNowsenyo != null">{{ disp.nuNowsenyo }} m&sup2;</label>
										<label v-else></label>
									</div>
								</div>
								<div class="contents-kazokuNinzu-first">
									<span class="contents__caution margin-mensekiTyui font-size">※ 親族・知人の住宅に住んでいる方は、住宅全体の面積</span>
								</div>
							</div>
						</div>
						<div class="form-section">
							<div class="form-section-wrap">
								<p class="item-name">住宅の設備</p>
								<div class="div_flex">
									<div class="contents__caution--div question_indent">
										<div class="contents__caution--div_mark">
											<p class=" contents__caution--multiple">・</p>
										</div>
										<div>
											<p class=" contents__caution--multiple">専用の台所</p>
										</div>
									</div>
									<div class="toggle_indent">
										{{ disp.fgDaidokoroName }}
									</div>
								</div>
								<br>
								<div class="div_flex">
									<div class="contents__caution--div question_indent">
										<div class="contents__caution--div_mark">
											<p class=" contents__caution--multiple">・</p>
										</div>
										<div>
											<p class=" contents__caution--multiple">専用のトイレ</p>
										</div>
									</div>
									<div class="toggle_indent">
										{{ disp.fgToiletName }}
									</div>
								</div>
								<br>
								<div class="div_flex">
									<div class="contents__caution--div question_indent">
										<div class="contents__caution--div_mark">
											<p class=" contents__caution--multiple">・</p>
										</div>
										<div>
											<p class=" contents__caution--multiple">専用の浴室</p>
										</div>
									</div>
									<div class="toggle_indent">
										{{ disp.fgYokusituName }}
									</div>
								</div>
							</div>
						</div>
						<div class="form-section background__color--light-gray">
							<div class="form-section-wrap">
								<p class="item-name">家賃を支払っている方</p>
								<div class="contents-kazokuNinzu-first line-height yatin-marginLeft">
									氏名：{{ disp.nmYatinname }}
								</div>
								<div class="line-height yatin-margin">
									<label v-if="co_isEmpty(form.cdYatintudukigara) || form.cdYatintudukigara != '7'">申込者との関係：{{ disp.cdYatintudukigaraName }}</label>
									<label v-else>申込者との関係：{{ disp.cdYatintudukigaraName }}（{{ disp.txYatintudukigaraetc }}）</label>
								</div>
							</div>
						</div>
						<div class="form-section">
							<div class="form-section-wrap">
								<p class="item-name">負担している家賃（月額）</p>
								<div id="contents--name__area">
									<div  class="contents-kazokuNinzu-first">{{ disp.cdNowyatinName }}</div>
								</div>
							</div>
						</div>
						<div class="form-section background__color--light-gray">
							<div class="form-section-wrap">
								<p class="item-name">住宅の劣化・危険性・環境など</p>
								<div class="div_flex">
									<div class="contents__caution--div question_indent">
										<div class="contents__caution--div_mark">
											<p class=" contents__caution--multiple">・</p>
										</div>
										<div>
											<p class=" contents__caution--multiple">建物の老朽化により、床、壁、天井等が著しく損傷又は汚損している（自損を除く）</p>
										</div>
									</div>
									<div class="toggle_indent">
										<div class="contents__input--toggle_btn" >
											{{ disp.fgNaihekiName }}
										</div>
									</div>
								</div>
								<br>
								<div class="div_flex">
									<div class="contents__caution--div question_indent">
										<div class="contents__caution--div_mark">
											<p class=" contents__caution--multiple">・</p>
										</div>
										<div>
											<p class=" contents__caution--multiple">建物の老朽化により、外壁の剝離・剝落・亀裂等の損傷がある又は金属部が腐食している</p>
										</div>
									</div>
									<div class="toggle_indent">
										<div class="contents__input--toggle_btn" >
											{{ disp.fgGaihekiName }}
										</div>
									</div>
								</div>
								<br>
								<div class="div_flex">
									<div class="contents__caution--div question_indent">
										<div class="contents__caution--div_mark">
											<p class=" contents__caution--multiple">・</p>
										</div>
										<div>
											<p class=" contents__caution--multiple">地盤沈下又は土台の腐食等により建物が傾き、倒壊のおそれがある</p>
										</div>
									</div>
									<div class="toggle_indent">
										<div class="contents__input--toggle_btn" >
											{{ disp.fgKatamukiName }}
										</div>
									</div>
								</div>
								<br>
								<div class="div_flex">
									<div class="contents__caution--div question_indent">
										<div class="contents__caution--div_mark">
											<p class=" contents__caution--multiple">・</p>
										</div>
										<div>
											<p class=" contents__caution--multiple">主となる居室に近接して建物があり、日照時間が著しく少ない<br>また、採光も少なく、曇天等の時は、昼間も電灯を点けることが多い</p>
										</div>
									</div>
									<div class="toggle_indent">
										<div class="contents__input--toggle_btn" >
											{{ disp.fgNisyoName }}
										</div>
									</div>
								</div>
								<br>
								<div class="div_flex">
									<div class="contents__caution--div question_indent">
										<div class="contents__caution--div_mark">
											<p class=" contents__caution--multiple">・</p>
										</div>
										<div>
											<p class=" contents__caution--multiple">周囲が木造の建物に隣接していて、火事や地震のときには危険な状態である</p>
										</div>
									</div>
									<div class="toggle_indent">
										<div class="contents__input--toggle_btn" >
											{{ disp.fgBousai1Name }}
										</div>
									</div>
								</div>
								<br>
								<div class="div_flex">
									<div class="contents__caution--div question_indent">
										<div class="contents__caution--div_mark">
											<p class=" contents__caution--multiple">・</p>
										</div>
										<div>
											<p class=" contents__caution--multiple">住んでいる建物の外廊下が狭い又は外階段が急である等、火事や地震のときには危険な状態である</p>
										</div>
									</div>
									<div class="toggle_indent">
										<div class="contents__input--toggle_btn" >
											{{ disp.fgBousai2Name }}
										</div>
									</div>
								</div>
								<br>
								<div class="div_flex">
									<div class="contents__caution--div question_indent">
										<div class="contents__caution--div_mark">
											<p class=" contents__caution--multiple">・</p>
										</div>
										<div>
											<p class=" contents__caution--multiple">住んでいる建物の一部に燃料や火薬などの危険物を取り扱っている店や倉庫がある</p>
										</div>
									</div>
									<div class="toggle_indent">
										<div class="contents__input--toggle_btn" >
											{{ disp.fgKikenbutuName }}
										</div>
									</div>
								</div>
								<br>
								<div class="div_flex">
									<div class="contents__caution--div question_indent">
										<div class="contents__caution--div_mark">
											<p class=" contents__caution--multiple">・</p>
										</div>
										<div>
											<p class=" contents__caution--multiple">工場に隣接又は近接した所に住んでおり、その工場の騒音や振動・煤煙・悪臭がひどい</p>
										</div>
									</div>
									<div class="toggle_indent">
										<div class="contents__input--toggle_btn" >
											{{ disp.fgSouon1Name }}
										</div>
									</div>
								</div>
								<br>
								<div class="div_flex">
									<div class="contents__caution--div question_indent">
										<div class="contents__caution--div_mark">
											<p class=" contents__caution--multiple">・</p>
										</div>
										<div>
											<p class=" contents__caution--multiple">４車線以上の道路又はバス路線等の道路に近接した所に住んでおり、自動車の騒音や振動がひどい</p>
										</div>
									</div>
									<div class="toggle_indent">
										<div class="contents__input--toggle_btn" >
											{{ disp.fgSouon2Name }}
										</div>
									</div>
								</div>
								<br>
								<div class="div_flex">
									<div class="contents__caution--div question_indent">
										<div class="contents__caution--div_mark">
											<p class=" contents__caution--multiple">・</p>
										</div>
										<div>
											<p class=" contents__caution--multiple">鉄道線路に近接した所に住んでおり、電車や列車の騒音や振動がひどい</p>
										</div>
									</div>
									<div class="toggle_indent">
										<div class="contents__input--toggle_btn" >
											{{ disp.fgSouon3Name }}
										</div>
									</div>
								</div>
								<br>
								<div class="div_flex">
									<div class="contents__caution--div question_indent">
										<div class="contents__caution--div_mark">
											<p class=" contents__caution--multiple">・</p>
										</div>
										<div>
											<p class=" contents__caution--multiple">ガード下や鉄道線路に面した所に住んでいる</p>
										</div>
									</div>
									<div class="toggle_indent">
										<div class="contents__input--toggle_btn" >
											{{ disp.fgSouon4Name }}
										</div>
									</div>
								</div>
								<br>
								<div class="div_flex">
									<div class="contents__caution--div question_indent">
										<div class="contents__caution--div_mark">
											<p class=" contents__caution--multiple">・</p>
										</div>
										<div>
											<p class=" contents__caution--multiple">飛行機の騒音がひどい</p>
										</div>
									</div>
									<div class="toggle_indent">
										<div class="contents__input--toggle_btn" >
											{{ disp.fgSouon5Name }}
										</div>
									</div>
								</div>
								<br>
								<div class="div_flex">
									<div class="contents__caution--div question_indent">
										<div class="contents__caution--div_mark">
											<p class=" contents__caution--multiple">・</p>
										</div>
										<div>
											<p class=" contents__caution--multiple">住んでいる建物に併設又は隣接して、午後１０時を過ぎても営業しているバー、スナック、カラオケ、飲食店、スーパー、コンビニがあり、騒音がひどい</p>
										</div>
									</div>
									<div class="toggle_indent">
										<div class="contents__input--toggle_btn" >
											{{ disp.fgSouon6Name }}
										</div>
									</div>
								</div>
								<br>
							</div>
						</div>
						<div class="form-section">
							<div class="form-section-wrap">
								<p class="item-name">住んでいる賃貸住宅を{{ disp.dtTatinokikigen }}までに立ち退かなければならない場合の理由 </p>
								<div style="margin-left: 17px;">
									<div id="contents--name__area" class="contents__enquete25">
										<label style="line-height: 22px;">
											{{ disp.kbTatinokiName }}
										</label>
									</div>
									<caution-message
										:classDiv="'contents__caution--div contents__nyukyotyui2'"
										:tyuibunItems="disp.kbTatinokiItems"
									/>
								</div>
							</div>
						</div>
						<div class="form-section background__color--light-gray">
							<div class="form-section-wrap">
								<p class="item-name">過去２年間のポイント方式募集で、応募して低順位となった募集の年月と整理番号</p>
								<div style="margin-left: 17px;">
									<div class="contents__div--PC">
										<div style="display: inline-grid;">
											<div class="chkbox-width">
												<label class="check-koubo1 kobo-label-display">	
													<div>
														<check-box
															:classDiv="'width-seiriNo'"
															:modelValue="form.kbKobo1"
															:name="'ポイント方式募集1'"
															:groupId="'kbKobo'"
															:listItems="disp.kobo1List"
															:disabledFlg="true"
															ref="kbKobo1"
														/>
													</div>
													<span>募集</span>
													<div v-if="!co_isEmpty(disp.noSeiri1)" class="seiribango-margin">整理番号：
														{{ disp.noSeiri1 }}
														<label style="margin-left:10px;">番</label>
													</div>
												</label>
											</div>
											<div class="chkbox-width">
												<label class="check-koubo2 kobo-label-display">	
													<div>
														<check-box
															:classDiv="'width-seiriNo'"
															:modelValue="form.kbKobo2"
															:name="'ポイント方式募集2'"
															:groupId="'kbKobo'"
															:listItems="disp.kobo2List"
															:disabledFlg="true"
															ref="kbKobo2"
														/>
													</div>
													<span>募集</span>
													<div v-if="!co_isEmpty(disp.noSeiri2)" class="seiribango-margin">整理番号：
														{{ disp.noSeiri2 }}
														<label style="margin-left:10px;">番</label>
													</div>
												</label>
											</div>
											<div class="chkbox-width">
												<label class="check-koubo3 kobo-label-display">	
													<div>
														<check-box
															:classDiv="'width-seiriNo'"
															:modelValue="form.kbKobo3"
															:name="'ポイント方式募集3'"
															:groupId="'kbKobo'"
															:listItems="disp.kobo3List"
															:disabledFlg="true"
															ref="kbKobo3"
														/>
													</div>
													<span>募集</span>
													<div v-if="!co_isEmpty(disp.noSeiri3)" class="seiribango-margin">整理番号：
														{{ disp.noSeiri3 }}
														<label style="margin-left:10px;">番</label>
													</div>
												</label>
											</div>
											<div class="chkbox-width">
												<label class="check-koubo4 kobo-label-display">	
													<div>
														<check-box
															:classDiv="'width-seiriNo'"
															:modelValue="form.kbKobo4"
															:name="'ポイント方式募集4'"
															:groupId="'kbKobo'"
															:listItems="disp.kobo4List"
															:disabledFlg="true"
															ref="kbKobo4"
														/>
													</div>
													<span>募集</span>
													<div v-if="!co_isEmpty(disp.noSeiri4)" class="seiribango-margin">整理番号：
														{{ disp.noSeiri4 }}
														<label style="margin-left:10px;">番</label>
													</div>
												</label>
											</div>
										</div>
									</div>
									<div class="contents__div--MOBILE">
										<div style="display: inline-grid;">
											<div class="chkbox-width">
												<label class="check-koubo1">	
													<div class="kobo-label-display">
														<check-box
															:classDiv="'width-seiriNo'"
															:modelValue="form.kbKobo1"
															:name="'ポイント方式募集1'"
															:groupId="'kbKobo'"
															:listItems="disp.kobo1List"
															:disabledFlg="true"
															ref="kbKobo1"
														/>
														<span class="kobo-margin">募集</span>
													</div>
												</label>
											</div>
											<div v-if="!co_isEmpty(disp.noSeiri1)" class="seiribango__div-margin">
												<span>整理番号：
													{{ disp.noSeiri1 }}
													<label style="margin-left:10px;">番</label>
												</span>
											</div>
											<div class="chkbox-width">
												<label class="check-koubo2">	
													<div class="kobo-label-display">
														<check-box
															:classDiv="'width-seiriNo'"
															:modelValue="form.kbKobo2"
															:name="'ポイント方式募集2'"
															:groupId="'kbKobo'"
															:listItems="disp.kobo2List"
															:disabledFlg="true"
															ref="kbKobo2"
														/>
														<span class="kobo-margin">募集</span>
													</div>
												</label>
											</div>
											<div v-if="!co_isEmpty(disp.noSeiri2)" class="seiribango__div-margin">
												<span>整理番号：
													{{ disp.noSeiri2 }}
													<label style="margin-left:10px;">番</label>
												</span>
											</div>
											<div class="chkbox-width">
												<label class="check-koubo3">	
													<div class="kobo-label-display">
														<check-box
															:classDiv="'width-seiriNo'"
															:modelValue="form.kbKobo3"
															:name="'ポイント方式募集3'"
															:groupId="'kbKobo'"
															:listItems="disp.kobo3List"
															:disabledFlg="true"
															ref="kbKobo3"
														/>
														<span class="kobo-margin">募集</span>
													</div>
												</label>
											</div>
											<div v-if="!co_isEmpty(disp.noSeiri3)" class="seiribango__div-margin">
												<span>整理番号：
													{{ disp.noSeiri3 }}
													<label style="margin-left:10px;">番</label>
												</span>
											</div>
											<div class="chkbox-width">
												<label class="check-koubo4">	
													<div class="kobo-label-display">
														<check-box
															:classDiv="'width-seiriNo'"
															:modelValue="form.kbKobo4"
															:name="'ポイント方式募集4'"
															:groupId="'kbKobo'"
															:listItems="disp.kobo4List"
															:disabledFlg="true"
															ref="kbKobo4"
														/>
														<span class="kobo-margin">募集</span>
													</div>
												</label>
											</div>
											<div v-if="!co_isEmpty(disp.noSeiri4)" class="seiribango__div-margin" style="margin-bottom:10px;">
												<span>整理番号：
													{{ disp.noSeiri4 }}
													<label style="margin-left:10px;">番</label>
												</span>
											</div>
											<div v-else style="margin-bottom:10px;"></div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="form-section">
							<div class="form-section-wrap">
								<p class="item-name">申告欄（住宅について補足事項）</p>
								<div id="contents--name__area">
									<div class="contents-kazokuNinzu-first contents-kazokuNinzu-first">
										<p class="contents__textarea--display" v-text="disp.txSinkoku"/>
									</div>
								</div>
							</div>
						</div>
					</tbody>
				</table>
				<br>
				<h2 class="contents__h2">誓約・同意事項について</h2>
				<table class="contents__table--stripe detail">
					<tbody>
						<tr>
							<th class="contents__input--title line-height">申込確定にあたっては、以下の事項に誓約・同意することが必要です。</th>
							<td class="padding__top--seiyaku font-size">
								<div class="doui-tyui">
									<seikyu-message
										:tyuibunItems="disp.seiyakuItems"
									/>
								</div>
								<div class="width-seiyakuDoui">
									<check-box
										:classDiv="'font-size'"
										:modelValue="form.fgSeiyakuDoui"
										:name="'誓約・同意'"
										:groupId="'fgSeiyakuDoui'"
										:listItems="disp.seiyakuDouiList"
										:disabledFlg="true"
										ref="fgSeiyakuDoui" />
								</div>
							</td>
						</tr>
					</tbody>
				</table>
				<br>
				<div align="center" class="contents__btn-statement">
					<div class="contents__caution--multiple btn-statement1">
						<label class="font-size">このまま申込む場合、「申込みを確定する」ボタンをクリックしてください。</label>
					</div>
					<div class="contents__caution--multiple btn-statement2">
						<label class="font-size">入力した内容を修正する場合、「入力内容を修正する」ボタンをクリックしてください。</label>
					</div>
				</div>
				<div class="contents__div--center margin__bottom-page">
					<a id="modal-open2" class="button-link2 decoration-none">
						<input
							type="button"
							value="申込みを確定する"
							class="contents__btn--confirm btn-itiji-hozon"
							tabindex="1"
							ref="mosikomiKakuteibtn"
							@click="clickMosikomiKakuteibtn"
						/>
					</a>
					<input
						type="button"
						value="入力内容を修正する"
						tabindex="2"
						class="contents__btn--cancel btn-modoru"
						@click="clickBackBtn"
					/>
				</div>
			</section>
		</div>
	</main>
</template>

<script>
import ErrorMessage from '@/components/ErrorMessage.vue';
import CautionMessage from '@/components/CautionMessage.vue';
import SeiyakuMessage from '@/components/SeiyakuMessage.vue';
import CheckBox from '@/components/CheckBox.vue';
import StepBar from '@/components/StepBar.vue';

import { co_post, co_put, co_setError } from '@/common/ajaxUtility.js';
import { co_getMessage } from '@/common/messageUtility.js';
import { co_confirmDialog, co_completedDialog } from '@/common/dialogUtility.js';
import { co_doLogout } from '@/common/logoutEventUtility.js';
import { co_toTop } from '@/common/screenUtility.js';
import { co_zenkaku2Hankaku } from '@/common/stringUtility.js';
import { co_isEmpty } from '@/common/checkUtility';
import { co_toTrans, co_clearParam } from '@/common/screenUtility.js';

import { HTTP_STATUS } from '@/const/const.js';
import { DIALOG_BUTTON_LIST_KEY } from '@/const/const.js';
import { STORE_ERROR_CLEAR, STORE_VIEW_PROGRESS, STORE_ERROR_SETMSG, STORE_VIEW_GET_PARAMS } from '@/const/store.js';
import { PATH_BC019_INIT, PATH_BC019_CHECK, PATH_BC019_EDIT_INFO } from '@/const/route.js';

export default {
	name: "BC019",
	components: {
		'error-message': ErrorMessage,
		'caution-message': CautionMessage,
		'seikyu-message': SeiyakuMessage,
		'check-box': CheckBox,
		'step-bar': StepBar,
	},
	data: function () {
		return {
			disp: {
				nmBosyu: '',					// 募集の種類名称
				nuNinzu1Name: '',				// 年齢別人数（11歳以下）名称
				nuNinzu2Name: '',				// 年齢別人数（12歳以上17歳以下）名称
				nuNinzu3Name: '',				// 年齢別人数（18歳以上64歳以下）名称
				nuNinzu4Name: '',				// 年齢別人数（65歳以上）名称
				nuNetakirininzuName: '',		// 寝たきり人数名称
				nuSyogaisyaninzuName: '',		// 障害者人数名称
				kbSintokyuName: '',				// 身体障害者手帳等級名称
				kbAiteidoName: '',				// 愛の手帳程度名称
				kbSeitokyuName: '',				// 精神障害者保健福祉手帳等級名称
				kbSyogaitokyuName: '',			// 年金証書の障害等級名称
				cdNowjyutakuName: '',			// 現在の住宅の種類名称
				jyutakuTyuiItems: [],			// 現在の住宅の種類注意文
				kbNowjyutakuName: '',			// 現在の住宅（親族・知人）名称
				kbJyutakukozoName: '',			// 現在の住宅の構造名称
				cdNowmadoriName: '',			// 現在の住宅の間取り名称
				nuNowsenyo: '',					// 現在の住宅の専用面積
				fgDaidokoroName: '',			// 台所の有無名称
				fgToiletName: '',				// トイレの有無名称
				fgYokusituName: '',				// 浴室の有無名称
				nmYatinname: '',				// 家賃を払っている方の氏名
				cdYatintudukigaraName: '',		// 家賃を払っている方の続柄名称
				txYatintudukigaraetc: '',		// 家賃を払っている方の続柄（その他）
				cdNowyatinName: '',				// 現在の家賃（月額）名称
				fgNaihekiName: '',				// 建物の不良度（床・壁・天井）名称
				fgGaihekiName: '',				// 建物の不良度（外壁）名称
				fgKatamukiName: '',				// 建物の不良度（傾き）名称
				fgNisyoName: '',				// 住環境水準（日照・通風）名称
				fgBousai1Name: '',				// 住環境水準（防災（木造））名称
				fgBousai2Name: '',				// 住環境水準（防災（外通路））名称
				fgKikenbutuName: '',			// 住環境水準（危険物）名称
				fgSouon1Name: '',				// 住環境水準（騒音・振動（工場））名称
				fgSouon2Name: '',				// 住環境水準（騒音・振動（道路））名称
				fgSouon3Name: '',				// 住環境水準（騒音・振動（電車））名称
				fgSouon4Name: '',				// 住環境水準（騒音・振動（路線））名称
				fgSouon5Name: '',				// 住環境水準（騒音・振動（飛行機））名称
				fgSouon6Name: '',				// 住環境水準（騒音・振動（商業施設））名称
				dtTatinokikigen: '',			// 立ち退き期限
				kbTatinokiName: '',				// 賃貸住宅の立ち退き理由名称
				ymKobo1: '',					// ポイント方式募集年月1
				noSeiri1: '',					// ポイント方式整理番号1
				ymKobo2: '',					// ポイント方式募集年月2
				noSeiri2: '',					// ポイント方式整理番号2
				ymKobo3: '',					// ポイント方式募集年月3
				noSeiri3: '',					// ポイント方式整理番号3
				ymKobo4: '',					// ポイント方式募集年月4
				noSeiri4: '',					// ポイント方式整理番号4
				txSinkoku: '',					// 申告欄
				kobo1List: [],					// ポイント方式募集1リスト
				kobo2List: [],					// ポイント方式募集2リスト
				kobo3List: [],					// ポイント方式募集3リスト
				kobo4List: [],					// ポイント方式募集4リスト
				seiyakuDouiList: [],			// 誓約・同意リスト
				seiyakuItems: ['C0027'],		// 制約・同意注意文
				kbTatinokiItems: ['C0229'],		// 賃貸住宅の立ち退き注意文
			},
			mosikomiInfo: [],	// 住宅状況入力情報
			co_zenkaku2Hankaku: co_zenkaku2Hankaku,
			co_isEmpty: co_isEmpty,
		}
	},
	mounted: async function () {
	},
	created: async function() {

		// エラーをクリア
		this.$store.commit(STORE_ERROR_CLEAR);

		// ローディング表示開始
		this.$store.commit(STORE_VIEW_PROGRESS, true);

		// 前画面からのパラメータを設定
		let param = this.$store.getters[STORE_VIEW_GET_PARAMS]('BC019');
		this.mosikomiInfo = param.mosikomiInfo;

		// 画面間パラメータを削除
		co_clearParam('BC019');

		// パラメータ設定
		this.form = this.mosikomiInfo;

		// コード名所取得
		let initInfo = await co_post(PATH_BC019_INIT, this.form);
		
		// 初期値設定
		// 募集の種類名称
		this.disp.nmBosyu = initInfo.nmBosyu;
		// 年齢別人数（11歳以下）名称
		this.disp.nuNinzu1Name = initInfo.nuNinzu1Name;
		// 年齢別人数（12歳以上17歳以下）名称
		this.disp.nuNinzu2Name = initInfo.nuNinzu2Name;
		// 年齢別人数（18歳以上64歳以下）名称
		this.disp.nuNinzu3Name = initInfo.nuNinzu3Name;
		// 年齢別人数（65歳以上）名称
		this.disp.nuNinzu4Name = initInfo.nuNinzu4Name;
		// 寝たきり人数名称
		this.disp.nuNetakirininzuName = initInfo.nuNetakirininzuName;
		// 障害者人数名称
		this.disp.nuSyogaisyaninzuName = initInfo.nuSyogaisyaninzuName;
		// 身体障害者手帳等級名称
		this.disp.kbSintokyuName = initInfo.kbSintokyuName;
		// 愛の手帳程度名称
		this.disp.kbAiteidoName = initInfo.kbAiteidoName;
		// 精神障害者保健福祉手帳等級名称
		this.disp.kbSeitokyuName = initInfo.kbSeitokyuName;
		// 年金証書の障害等級名称
		this.disp.kbSyogaitokyuName = initInfo.kbSyogaitokyuName;
		// 現在の住宅の種類名称
		this.disp.cdNowjyutakuName = initInfo.cdNowjyutakuName;
		// 現在の住宅（親族・知人）名称
		if (initInfo.kbNowjyutakuName == null) {
			this.disp.kbNowjyutakuName = '';
		} else {
			this.disp.kbNowjyutakuName = initInfo.kbNowjyutakuName;
		}
		// 現在の住宅の構造名称
		this.disp.kbJyutakukozoName = initInfo.kbJyutakukozoName;
		// 現在の住宅の間取り名称
		this.disp.cdNowmadoriName = initInfo.cdNowmadoriName;
		// 現在の住宅の専用面積
		this.disp.nuNowsenyo = this.mosikomiInfo.nuNowsenyo;
		// 台所の有無名称
		this.disp.fgDaidokoroName = initInfo.fgDaidokoroName;
		// トイレの有無名称
		this.disp.fgToiletName = initInfo.fgToiletName;
		// 浴室の有無名称
		this.disp.fgYokusituName = initInfo.fgYokusituName;
		// 家賃を払っている方の氏名
		this.disp.nmYatinname = this.mosikomiInfo.nmYatinname;
		// 家賃を払っている方の続柄名称
		this.disp.cdYatintudukigaraName = initInfo.cdYatintudukigaraName;
		// 家賃を払っている方の続柄（その他）
		this.disp.txYatintudukigaraetc = this.mosikomiInfo.txYatintudukigaraetc;
		// 現在の家賃（月額）名称
		this.disp.cdNowyatinName = initInfo.cdNowyatinName;
		// 建物の不良度（床・壁・天井）名称
		this.disp.fgNaihekiName = initInfo.fgNaihekiName;
		// 建物の不良度（外壁）名称
		this.disp.fgGaihekiName = initInfo.fgGaihekiName;
		// 建物の不良度（傾き）名称
		this.disp.fgKatamukiName = initInfo.fgKatamukiName;
		// 住環境水準（日照・通風）名称
		this.disp.fgNisyoName = initInfo.fgNisyoName;
		// 住環境水準（防災（木造））名称
		this.disp.fgBousai1Name = initInfo.fgBousai1Name;
		// 住環境水準（防災（外通路））名称
		this.disp.fgBousai2Name = initInfo.fgBousai2Name;
		// 住環境水準（危険物）名称
		this.disp.fgKikenbutuName = initInfo.fgKikenbutuName;
		// 住環境水準（騒音・振動（工場））名称
		this.disp.fgSouon1Name = initInfo.fgSouon1Name;
		// 住環境水準（騒音・振動（道路））名称
		this.disp.fgSouon2Name = initInfo.fgSouon2Name;
		// 住環境水準（騒音・振動（電車））名称
		this.disp.fgSouon3Name = initInfo.fgSouon3Name;
		// 住環境水準（騒音・振動（路線））名称
		this.disp.fgSouon4Name = initInfo.fgSouon4Name;
		// 住環境水準（騒音・振動（飛行機））名称
		this.disp.fgSouon5Name = initInfo.fgSouon5Name;
		// 住環境水準（騒音・振動（商業施設））名称
		this.disp.fgSouon6Name = initInfo.fgSouon6Name;
		// 立ち退き期限
		this.disp.dtTatinokikigen = initInfo.dtTatinokikigen;
		// 賃貸住宅の立ち退き理由名称
		this.disp.kbTatinokiName = initInfo.kbTatinokiName;
		// ポイント方式募集年月1
		this.disp.ymKobo1 = initInfo.ymKobo1;
		// ポイント方式整理番号1
		this.disp.noSeiri1 = this.mosikomiInfo.noSeiri1;
		// ポイント方式募集年月2
		this.disp.ymKobo2 = initInfo.ymKobo2;
		// ポイント方式整理番号2
		this.disp.noSeiri2 = this.mosikomiInfo.noSeiri2;
		// ポイント方式募集年月3
		this.disp.ymKobo3 = initInfo.ymKobo3;
		// ポイント方式整理番号3
		this.disp.noSeiri3 = this.mosikomiInfo.noSeiri3;
		// ポイント方式募集年月4
		this.disp.ymKobo4 = initInfo.ymKobo4;
		// ポイント方式整理番号4
		this.disp.noSeiri4 = this.mosikomiInfo.noSeiri4;
		// 申告欄
		this.disp.txSinkoku = this.mosikomiInfo.txSinkoku;

		// ポイント方式募集1
		this.disp.kobo1List = [
			{ idCd: '1', nmCd: co_zenkaku2Hankaku(this.disp.ymKobo1)}
		];
		// ポイント方式募集2
		this.disp.kobo2List = [
			{ idCd: '1', nmCd: co_zenkaku2Hankaku(this.disp.ymKobo2)}
		];
		// ポイント方式募集3
		this.disp.kobo3List = [
			{ idCd: '1', nmCd: co_zenkaku2Hankaku(this.disp.ymKobo3)}
		];
		// ポイント方式募集4
		this.disp.kobo4List = [
			{ idCd: '1', nmCd: co_zenkaku2Hankaku(this.disp.ymKobo4) }
		];
		// 制約・同意
		this.disp.seiyakuDouiList = [
			{ idCd: '1', nmCd: '上記について誓約・同意する'}
		];

		// 現在の住宅の種類注意文
		if(this.form.cdNowjyutaku == '9') {
			this.disp.jyutakuTyuiItems = ['C0026'];
		} else if(this.form.cdNowjyutaku == '7' || this.form.cdNowjyutaku == '8') {
			this.disp.jyutakuTyuiItems = ['C0025'];
		}

		// ローディング表示終了
		this.$store.commit(STORE_VIEW_PROGRESS, false);

	},
	methods: {
		// 申込みを確定するボタン押下
		clickMosikomiKakuteibtn: async function () {

			// エラーをクリア
			this.$store.commit(STORE_ERROR_CLEAR);

			// 確認メッセージ表示
			co_confirmDialog(co_getMessage('W0010'), this.doMosikomi);
		},
		doMosikomi: async function (flg) {
			
			// ダイアログ「はい」ボタン押下時処理
			if (flg == DIALOG_BUTTON_LIST_KEY.OK) {

				// ローディング表示開始
				this.$store.commit(STORE_VIEW_PROGRESS, true);

				let self = this;
				let checkRet = await co_post(PATH_BC019_CHECK, this.form, function (res, handle) {
					if (res.status == HTTP_STATUS.OK) {
						return handle(res);
					} else {
						// ローディング表示終了
						self.$store.commit(STORE_VIEW_PROGRESS, false);
					}
				});

				if (checkRet != null) {
					if (!checkRet.checkMosikomi) {
						// 申込重複エラー
						// 募集年月の日付フォーマット変換
						let ymBosyu = this.form.ymBosyu.substring(0, 4) + '年' + this.form.ymBosyu.substring(4, 6) + '月';

						// エラーメッセージ：E0020を表示
						this.$store.commit(STORE_ERROR_SETMSG, co_getMessage('E0020', this.disp.nmBosyu, ymBosyu));

						// ローディング表示終了
						this.$store.commit(STORE_VIEW_PROGRESS, false);

						// ページトップへ遷移
						co_toTop();

						return;
					}

					// ローディング表示終了
					this.$store.commit(STORE_VIEW_PROGRESS, false);

					if (!checkRet.checkRiyosya) {
						// 利用者情報相違
						// 確認メッセージ表示
						co_confirmDialog(co_getMessage('W0003'), this.doUpdateRiyosya);
					} else {
						// 申込み内容登録
						this.form.updateRiyosya = false;
						this.doMosikomiEntry();
					}
				}
			}

			// ダイアログ「いいえ」ボタン押下時処理
			if (flg == DIALOG_BUTTON_LIST_KEY.CANCEL) {
				// ダイアログを閉じる
				return;
			}
		},
		// 利用者情報の更新設定
		doUpdateRiyosya : function (flg) {
			if (flg == DIALOG_BUTTON_LIST_KEY.OK) {
				// 利用者情報の更新設定
				this.form.updateRiyosya = true;
			} else {
				this.form.updateRiyosya = false;
			}

			// 申込み内容登録
			this.doMosikomiEntry();
		},
		// 申込み内容登録処理
		doMosikomiEntry : async function () {
			// ローディング表示開始
			this.$store.commit(STORE_VIEW_PROGRESS, true);

			// 申込み内容登録
			await co_put(PATH_BC019_EDIT_INFO, this.form, this.callbackEntry);
		},
		// 申込み内容登録処理(コールバック関数)
		callbackEntry: function (res) {
			// 申込み内容登録処理：正常終了
			if (res.status == HTTP_STATUS.CREATED) {
				// プログレスバー非表示
				this.$store.commit(STORE_VIEW_PROGRESS, false);

				// 完了メッセージ表示
				co_completedDialog(co_getMessage('I0003'), this.doCompleted);

			} else {
				// 業務エラー表示
				co_setError(res.data, this.$refs);

				// プログレスバー非表示
				this.$store.commit(STORE_VIEW_PROGRESS, false);
			}
		},
		doCompleted: function (flg) {
			
			// ダイアログ「はい」ボタン押下時処理
			if (flg == DIALOG_BUTTON_LIST_KEY.OK) {

				// ログアウト実行
				co_doLogout();

				// ログイン画面へ遷移する
				co_toTrans('BC001');
			}

		},
		// 入力内容を修正するボタン押下
		clickBackBtn: function () {

			// 住宅状況入力画面へ遷移する。
			let params = { 
							transKbn: this.form.transKbn,
							mosikomiInfo: this.form,
							kbBosyu: this.form.kbBosyu,
							kbZyutaku: this.form.kbZyutaku,
							ymBosyu: this.form.ymBosyu,
							noMouchiku: this.form.noMouchiku,
							noRenzoku: this.form.noRenzoku,
							noUketuke: this.form.noUketuke
						};
			co_toTrans('BC018', params);
		},
	}
}
</script>

<style scoped>

.form-section .form-section-wrap .item-name {
	font-size: 16px;
	letter-spacing: 0.1px;
	line-height: 24px;
	color: #202124;
	font-weight: bold;
	width: 100%;
	word-break: break-word;
	margin-bottom: 16px;
}

.margin-madoriTyui {
	margin-top: 15px;
}

.margin-mensekiTyui {
	line-height: 1.2em;
	padding-top: 15px;
	display: flex;
}

.contents__enquete25 {
	margin-top: 10px;
}

.div_flex {
	display:flex;
	flex-direction: column;
}

.toggle_indent {
	margin-left: 34px;
}

.question_indent {
	margin-left: 17px;
}

/* 端末がPCの場合 */
@media screen and (min-width: 768px) {

	.contents__main {
		margin-left: 1% !important;
		margin-right: 1% !important;
	}

	.contents__div--MOBILE {
		display: none;
	}

	.font-size {
		font-size: 16px !important;
	}

	.contents__input-main {
		margin-top: -2%;
	}

	.contents__mosikomi {
		margin-top: 1% !important;
		display: inline-block;
	}

	.contents__table--stripe td {
		line-height: 0px;
	}

	.width-seiyakuDoui {
		margin-top: 20px;   
		margin-bottom: 15px;
		margin-left: -10px;
	}

	.contents__btn-statement {
		font-size: 16px;
		text-align: left;
		padding-left: 16%;
		margin-top: 15px;
		margin-bottom: 15px;
	}

	.btn-statement1,
	.btn-statement2 {
		display: inline-block;
		text-align: left;
		width: 82%;
	}

	.btn-itiji-hozon {
		margin-bottom: 2%;
		margin-right: 1%;
	}

	.btn-modoru {
		margin-left: 1%;
	}

	.detail .no_border_bottom .detail_split {
		border-bottom: none;
	}

	.contents__thtd--btn {
		background-color: #fdfdfd;
		border-color: #fdfdfd;
	}

	.content {
		display:none;
	}

	.contents__caution--multiple {
		line-height: 1.4em !important;
	}

	.padding__top--seiyaku {
		padding-top: 5px !important;
	}

	.contents-kazokuNinzu-first,
	.contents-syogaiTokyu-first {
		margin-left:15px;
	}

	.contents-kazokuNinzu,
	.contents-syogaiTokyu {
		margin-top: 10px !important;
		margin-left:15px;
	}

	.contents-syogaiTokyu2 {
		margin-top: 10px !important;
		margin-left: 48px;
	}

	.contents-kazokuNinzu-last,
	.contents-syogaiTokyu-last {
		margin-top: 10px !important;
		margin-left:15px;
	}

	.form-section {
		display: flex;
		border: 1px solid #dadce0;
		border-radius: 8px;
		margin-left: 25px;
		margin-bottom: 12px;
		background-color: #fdfdfd;
	}

	.form-section .form-section-wrap {
		padding: 0 10px 24px 24px;
	}

	.width-seiyakuDoui {
		margin-top: 25px;   
		margin-bottom: 15px;
		margin-left: -10px;
	}

	.yatin-margin {
		margin-left: 15px;
		margin-top: 15px;
	}

	.margin-top-10 {
		margin-top: 10px;
	}

	.check-koubo1 {
		margin-top: 15px;
		padding-left: 10px !important;
	}

	.check-koubo2,
	.check-koubo3 {
		padding-left: 10px !important;
	}

	.check-koubo4 {
		padding-left: 10px !important;
		margin-bottom: -20px !important;
	}

	.kobo-label-display {
		display: flex;
	}

	.width-seiriNo {
		font-size: 16px;
		margin-left: -15px;
		margin-bottom: 25px;
	}

	_:lang(x)+_:-webkit-full-screen-document, .width-seiriNo {
		width: 161px;
	}

	_:lang(x)+_:-webkit-full-screen-document, .kobo-margin {
		width: 32px;
	}

	.seiribango-margin {
		margin-left: 40px;
	}

	_:lang(x)+_:-webkit-full-screen-document, .seiribango-margin {
		width: 250px;
	}
}

/* 端末がスマホの場合 */
@media screen and (max-width: 767px) {

	.padding__top--seiyaku {
		padding-top: 0px !important;
	}

	.line-height {
		line-height: 25px !important;
	}

	.font-size {
		font-size: 18px !important;
	}

	.contents__div--PC {
		display: none;
	}

	.contents__main {
		margin-left: 3px !important;
		margin-right: 3px !important;
	}

	.contents__mosikomi {
		margin-top: 15px !important;
		font-size: 18px !important;
	}

	.contents__btn-statement {
		font-size: 18px;
		text-align: left;
		padding-left: 15px;
		margin-top: 15px;
	}

	.btn-statement1,
	.btn-statement2 {
		display: inline-block;
		text-align: left;
		margin-bottom: 20px;
	}

	.contents__btn--confirm {
		margin-top: 20px;
		margin-bottom: 20px;
		position: relative;
	}

	.detail tr:nth-child(even){
		background-color: #f1f2f5;
	}

	.detail th:nth-child(1) {
		width: auto;
	}

	.detail td:nth-child(2) {
		width: auto;
	}

	.content {
		display:none;
	}

	.contents__caution--multiple {
		line-height: 1.4em;
	}

	.width-seiyakuDoui {
		margin-left: -10px;
	}

	.contents-kazokuNinzu,
	.contents-syogaiTokyu {
		margin-top: 0px !important;
	}
	
	.contents-syogaiTokyu2 {
		margin-top: 0px !important;
	}

	.contents-kazokuNinzu-last,
	.contents-syogaiTokyu-last {
		margin-top: 0px !important;
		margin-bottom: 0px !important;
	}

	.form-section {
		display: flex;
		border: 1px solid #dadce0;
		border-radius: 8px;
		margin-bottom: 12px;
		background-color: #fdfdfd;
	}

	.form-section .form-section-wrap {
		padding: 0 10px 20px 10px;
	}

	.yatin-marginLeft {
		margin-left: 15px;
	}

	.yatin-margin {
		margin-left: 15px;
		margin-top: 15px;
	}

	.margin-top-10 {
		margin-top: 10px;
	}

	.line-height {
		line-height: 21px !important;
	}

	.check-koubo1 {
		margin-left: 0px !important;
	}

	.check-koubo2,
	.check-koubo3,
	.check-koubo4 {
		margin-left: -20px !important;
		padding-left: 10px !important;
		margin-top: 18px;
	}

	.kobo-margin {
		margin-left: 10px;
		margin-top: 3px;
	}

	_:lang(x)+_:-webkit-full-screen-document, .kobo-margin {
		width: 36px;
	}

	.kobo-label-display {
		display: flex;
		margin-left: -15px !important;
	}

	.width-seiriNo {
		font-size: 18px;
		line-height: 24px;
	}

	_:lang(x)+_:-webkit-full-screen-document, .width-seiriNo {
		width: 175px;
	}

	.seiribango-margin {
		margin-left: 40px;
	}

	.seiribango__div-margin {
		margin-top: 15px;
		margin-left: 25px;
	}

	_:lang(x)+_:-webkit-full-screen-document, .seiribango__div-margin {
		width: 275px;
	}
}
</style>